"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { PLATFORM_BILLING_REPLY_TO_EMAIL } from "@/lib/platform-billing-contract";

const items = [
  {
    q: "Do operators need a Paxom account first?",
    a: "No. You send a private link. They open the agreement and authorize ACH. No password.",
  },
  {
    q: "What do they authorize?",
    a: "A 12-month Paxom service agreement and monthly ACH for the plan on their invite. Amounts and dates are on that page, not guessed here.",
  },
  {
    q: "Can I change the price for one restaurant?",
    a: "Yes, on the invite. Catalog prices stay on this page. Intro or waived setup is written on their authorization page so Stripe matches what they see.",
  },
  {
    q: "What if they have a question before they pay?",
    a: `They write ${PLATFORM_BILLING_REPLY_TO_EMAIL}. We answer before they need to take the next step.`,
  },
] as const;

export function PaxomBillingLandingFaq() {
  return (
    <Accordion type="single" collapsible className="w-full">
      {items.map((item, index) => (
        <AccordionItem key={item.q} value={`item-${index}`}>
          <AccordionTrigger className="text-left text-base">
            {item.q}
          </AccordionTrigger>
          <AccordionContent className="text-sm leading-6 text-muted-foreground">
            {item.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
